import { css } from 'lit'

/**
 * Gemeinsame Tokens und Grundstile für alle kil-Komponenten.
 * Die Farbwerte selbst liegen als Custom Properties auf :root (siehe index.html),
 * damit sie von außen überschreibbar bleiben und Dark Mode zentral schaltet.
 */
export const tokens = css`
  :host {
    box-sizing: border-box;
    font-family: var(--kil-font-ui);
    color: var(--kil-ink);
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  .eyebrow {
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    font-stretch: 112%;
    color: var(--kil-ink-dim);
  }

  .mono {
    font-family: var(--kil-font-mono);
    font-variant-numeric: tabular-nums;
  }

  .card {
    background: var(--kil-surface);
    border: 1px solid var(--kil-line);
    border-radius: var(--kil-radius);
    padding: var(--kil-gap);
  }

  @media (prefers-reduced-motion: reduce) {
    :host {
      --kil-motion: 0ms;
    }
  }
`
